import { Container, Grid, Link, Text } from "basis";
import { FC } from "react";
import { CreditCard } from "../CreditCard/CreditCard";
import { SvgInline } from "../SvgInline/SvgInline";
import { State } from "./types";

interface Props {
  state: State;
}

export const Error: FC<Props> = ({ state }) => {
  const { accountInfo } = state;

  return (
    <Grid rowsGap="8">
      {accountInfo && (
        <Container padding="4" bg="grey.t05">
          <CreditCard
            cardName={accountInfo.cardName}
            cardEndsWith={accountInfo.cardEndsWith}
          />
        </Container>
      )}
      <SvgInline name="error-dog" width="236" />
      <Text textStyle="heading5" textStyle-sm="heading4">
        We were unable to retrieve the status of your request.
      </Text>
      <Text>Try to refresh or check back again later.</Text>
      <Link
        newTab={false}
        appearance="primary-button"
        width="216"
        href="/manage-account"
      >
        Manage account
      </Link>
    </Grid>
  );
};
